<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="halftitle"></a><a id="page_i"></a><strong>DON’T VOTE</strong></p>
<p class="center">It Just Encourages the Bastards</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?1a4696af